<template>
  <el-form-item :label="label" :prop="inputProp" class="currency-amount-item">
    <el-input type="text" class="currency-input" v-model="inputInnerValue" @blur="blurHandler" @input="inputHandler" :disabled="inputDisabled" :placeholder="placeholder" autofocus>
      <template slot="append">
        <div class="currency-select">
          <el-form-item :prop="selectProp">
            <el-select v-model="selectInnerValue" popper-class="currency-options" @change="changeHandler" :disabled="selectDisabled">
              <template slot="prefix">
                <div class="currency-option seleced-value">
                  <el-image v-if="selectInnerValue" style="width:30px;height: 30px"
                    :src="getCurrencyImage(((option && option.currency) ? selectInnerValue[option.currency] :  selectInnerValue.currency))
                    ? require(`@/assets/images/currency/${(option && option.currency) ? selectInnerValue[option.currency] :  selectInnerValue.currency}.png`): ''">
                  </el-image>
                  <div class="option-text" v-if="selectInnerValue">
                    <div class="name">{{(option && option.currency) ? selectInnerValue[option.currency] :  selectInnerValue.currency}}</div>
                    <div class="amount">{{(option && option.amount) ? selectInnerValue[option.amount] :  selectInnerValue.amount}}</div>
                  </div>
                </div>
              </template>
              <template v-for="(optionItem, optionIndex) in options">
                <el-option :value="optionItem" :key="optionIndex">
                  <div class="currency-option">
                    <el-image style="width:30px;height: 30px"
                      :src="getCurrencyImage(((option && option.currency) ? optionItem[option.currency] :  optionItem.currency))
                      ?
                      require(`@/assets/images/currency/${((option && option.currency) ? optionItem[option.currency] :  optionItem.currency)}.png`) : ''">
                    </el-image>
                    <div class="option-text">
                      <div class="name">{{(option && option.currency) ? optionItem[option.currency] :  optionItem.currency}}</div>
                      <div class="amount">{{(option && option.amount) ? optionItem[option.amount] :  optionItem.amount}}</div>
                    </div>
                  </div>
                </el-option>
              </template>
            </el-select>
          </el-form-item>
        </div>
      </template>
    </el-input>
  </el-form-item>
</template>
<script>
import { getCurrencyImage } from '@/utils/tools/currency';
export default {
  name: 'rhcn-currency-amount',
  props: {
    label: {
      type: String,
      default: '',
    },
    inputValue: {
      type: [String, Number],
      default: null,
    },
    selectValue: {
      type: [Object, String],
      default: '',
    },
    inputProp: {
      type: String,
      default: '',
    },
    selectProp: {
      type: String,
      default: '',
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    selectDisabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array, // [{value: 'USD', amount: 50}] 需要有value字段，不然在select选中会有问题
      default: () => [],
    },
    option: {
      currency: {
        type: String,
        default: 'value',
      },
      amount: {
        type: Number,
        default: null,
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['on-blur', 'on-input', 'on-change'],
  data() {
    return {
      inputInnerValue: this.inputValue,
      selectInnerValue: null,
    };
  },
  methods: {
    blurHandler() {
      this.$emit('on-blur');
    },
    inputHandler(value) {
      this.$emit('update:inputValue', this.inputInnerValue);
      this.$emit('on-input', value); // 如果父组件对数据进行format导致父组件的值不需要变动，请手动在父组件设置inputInnerValue的值
    },
    changeHandler() {
      this.$emit('update:selectValue', this.selectInnerValue);
      this.$emit('on-change', this.selectInnerValue);
    },
    getCurrencyImage,
  },
  watch: {
    inputValue() {
      this.inputInnerValue = this.inputValue;
    },
    selectValue() {
      this.selectInnerValue = this.selectValue;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.currency-amount-item {
  &.el-form-item {
    position: relative;
    margin-bottom: 0;
    .el-form-item__label {
      position: absolute;
      z-index: 1;
      left: 18px;
      top: 10px;
      line-height: 19px;
      font-size: 14px;
    }
    .el-form-item__error {
      position: absolute;
      z-index: 1;
    }
    .currency-input {
      &>.el-input__inner {
        height: 70px;
        padding-top: 29px;
        padding-left: 18px;
        box-sizing: border-box;
        font-size: 20px;
        font-weight: bold;
      }
      .currency-select {
        position: relative;
        .el-form-item__error {
          margin-top: 9px;
        }
        .el-select {
          .el-input {
            width: 166px;
            height: 70px;
            .el-input__inner {
              height: 70px;
              background: $color-text-primary;
              color: $color-white;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
            .el-input__suffix {
              .el-select__caret {
                color: $color-text-default-button;
              }
            }
          }
        }
        .currency-values {
          position: absolute;
          width: 166px;
          height: 70px;
          left: -20px;
          top: -10px;
          background: $color-text-primary;
        }
      }
    }
  }
}
.currency-options {
  width: 166px;
  .el-select-dropdown__item {
    height: inherit;
  }
}
.currency-option {
  padding: 10px 0;
  display: flex;
  align-items: center;
  &.seleced-value {
    background: $color-text-primary;
    padding-left: 15px;
    height: 70px;
    box-sizing: border-box;
    .option-text {
      color: $color-white;
      text-align: left;
    }
  }
  .option-text {
    margin-left: 13px;
    .name {
      font-size: 19px;
      font-weight: 800;
      line-height: 24px;
    }
    .amount {
      font-size: 14px;
      font-weight: 800;
      line-height: 19px;
    }
  }
}
</style>
